export const SHOW_SIDE_MENU = 'SHOW_SIDE_MENU'
export const HIDE_SIDE_MENU = 'HIDE_SIDE_MENU'

export const SET_SIDE_MENU_LINKS = 'SET_SIDE_MENU_LINKS'
export const SET_SIDE_MENU_ITEMS = 'SET_SIDE_MENU_ITEMS'